module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/introduction01_sp-256d5c2a97777c440c63c6b5eb98ffaa.png";